var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaveDoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2454 3.24479C14.2408 3.20653 14.1957 2.86421 13.9628 2.63111L12.1023 0.770548C11.8694 0.537694 11.5269 0.492339 11.4886 0.488032C11.479 0.487018 11.4694 0.486511 11.4597 0.486511H1.83135C1.13278 0.486511 0.564453 1.05484 0.564453 1.7534V15.4358C0.564453 16.1344 1.13278 16.7027 1.83135 16.7027H12.98C13.6786 16.7027 14.2469 16.1344 14.2469 15.4358V3.27367C14.2469 3.26405 14.2464 3.25442 14.2454 3.24479Z",
    fill: "url(#paint0_linear_154_7)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6995 9.60815H4.1117C3.69261 9.60815 3.35156 9.9492 3.35156 10.3683V15.9426C3.35156 16.3617 3.69261 16.7027 4.1117 16.7027H10.6995C11.1186 16.7027 11.4597 16.3617 11.4597 15.9426V10.3683C11.4597 9.9492 11.1186 9.60815 10.6995 9.60815Z",
    fill: "url(#paint1_linear_154_7)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6995 1.5H4.1117C3.69261 1.5 3.35156 1.84105 3.35156 2.26014V5.30068C3.35156 5.71976 3.69261 6.06081 4.1117 6.06081H10.6995C11.1186 6.06081 11.4597 5.71976 11.4597 5.30068V2.26014C11.4597 1.84105 11.1186 1.5 10.6995 1.5Z",
    fill: "url(#paint2_linear_154_7)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1932 2.51355H9.43307C9.2932 2.51355 9.17969 2.62706 9.17969 2.76693V4.79396C9.17969 4.93382 9.2932 5.04733 9.43307 5.04733H10.1932C10.3331 5.04733 10.4466 4.93382 10.4466 4.79396V2.76693C10.4466 2.62706 10.3331 2.51355 10.1932 2.51355Z",
    fill: "url(#paint3_linear_154_7)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9803 13.9156H12.2202C12.0803 13.9156 11.9668 14.0291 11.9668 14.169V14.9291C11.9668 15.069 12.0803 15.1825 12.2202 15.1825H12.9803C13.1202 15.1825 13.2337 15.069 13.2337 14.9291V14.169C13.2337 14.0291 13.1202 13.9156 12.9803 13.9156Z",
    fill: "url(#paint4_linear_154_7)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.59164 13.9156H1.8315C1.69164 13.9156 1.57812 14.0291 1.57812 14.169V14.9291C1.57812 15.069 1.69164 15.1825 1.8315 15.1825H2.59164C2.7315 15.1825 2.84502 15.069 2.84502 14.9291V14.169C2.84502 14.0291 2.7315 13.9156 2.59164 13.9156Z",
    fill: "url(#paint5_linear_154_7)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_154_7",
    x1: 0.30246,
    y1: 15.6978,
    x2: 13.6659,
    y2: 2.3344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1877F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04BCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_154_7",
    x1: 3.82791,
    y1: 16.7332,
    x2: 10.9833,
    y2: 9.57775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3D8F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E7F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_154_7",
    x1: 4.46136,
    y1: 6.72466,
    x2: 10.3499,
    y2: 0.836149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3D8F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E7F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_154_7",
    x1: 8.9372,
    y1: 4.65637,
    x2: 10.6891,
    y2: 2.90451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005ECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2488FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_154_7",
    x1: 12.041,
    y1: 15.1082,
    x2: 13.1594,
    y2: 13.9898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005ECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2488FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_154_7",
    x1: 1.65236,
    y1: 15.1082,
    x2: 2.77078,
    y2: 13.9898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005ECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2488FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveDoc);
export default __webpack_public_path__ + "static/media/saveDoc.2da6bc15f133706ffd750fd9f7a3fac0.svg";
export { ForwardRef as ReactComponent };